import { useMutation } from '@tanstack/react-query'
import { apiClient, handleApiError } from '@/infrastructure/api/client'

export function useUploadImage() {
  return useMutation({
    mutationFn: async (file: File): Promise<string> => {
      const formData = new FormData()
      formData.append('file', file)

      // The shared apiClient sets a default 'application/json' Content-Type
      // header. Axios's transformRequest special-cases FormData when the
      // Content-Type looks like JSON: it JSON-stringifies the FormData's
      // entries instead of sending it as multipart -- since a File has no
      // enumerable properties, it serializes to an empty object, silently
      // dropping the file. Clearing the header (rather than pinning it to
      // 'multipart/form-data', which has no boundary parameter and so can't
      // be parsed by the server) lets axios/the browser set the correct
      // multipart Content-Type with boundary instead.
      const response = await apiClient.post<{ url: string }>('/upload/image', formData, {
        headers: { 'Content-Type': undefined },
      })
      return response.data.url
    },
    onError: (error: unknown) => {
      throw new Error(handleApiError(error))
    },
  })
}
